import React, {Fragment, useContext, useEffect, useState} from 'react';

import {Form, FormGroup} from 'reactstrap';

import {useForm} from "react-hook-form";
import {Btn} from "../../../../../AbstractElements";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import BackendDropDown from "../../../../../CommonElements/DropDown/BackendDropDown";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {ExtraField, ExtraFieldFormValues, ExtraFieldFormProps} from "../../Types/ExtraFieldTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

const ExtraFieldForm: React.FC<ExtraFieldFormProps> = ({callBack, extraField}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register, handleSubmit, setError, clearErrors, formState: {errors}, setValue, getValues, watch
    } = useForm<ExtraFieldFormValues>();

    useEffect(() => {
        if (extraField) {
            setValue('field_type_id', extraField.field_type_id || 0);
            setValue('model', extraField.model);
            setValue('key', extraField.key);
            setValue('label', extraField.label);
            setValue('placeholder', extraField.placeholder);
            setValue('required', extraField.required);
        }
    }, [extraField, setValue])

    const onSubmit = (data: ExtraFieldFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        extraField ? updateExtraField(data) : createExtraField(data);
    }

    const createExtraField = (data: ExtraFieldFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        axiosConfig
            .post(`/system-core/extra-field`, data)
            .then((response: { data: { data: ExtraField; }; }) => {
                if (response?.data?.data) {
                    callBack?.(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    const updateExtraField = (data: ExtraFieldFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        if (!extraField) return;
        axiosConfig
            .put(`/system-core/extra-field/${extraField.id}`, data)
            .then((response: { data: { data: ExtraField; }; }) => {
                if (response?.data?.data) {
                    callBack?.(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    useEffect(() => {
        watch('label') ? setValue('key', (`${watch('model')} ${watch('label')}`).toLowerCase()
            .replace(/\s+/g, '-')) : setValue('key', '');
    }, [watch('label'), watch('model'), setValue]);


    return (<Fragment>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Loader visibility={loaderVisibility}/>
            <BackendDropDown name={'model'} type={'select-url'} label={'Model'} register={register}
                             getValues={getValues}
                             errors={errors} url={'system-core/get-model-list'} options={{required: true}}/>
            <BackendDropDown name={'field_type_id'} params={{setting_key: 'extra-field-type'}} type={'select-url'}
                             label={'Field Type'} register={register}
                             getValues={getValues}
                             errors={errors} url={'system-core/configuration'} options={{required: true}}/>
            <TextInput name={'label'} type={'text'} label={'label'} register={register}
                       errors={errors} placeholder={'Label'} options={{required: true}}/>
            <TextInput name={'key'} type={'text'} label={'Key'} readOnly={true} register={register}
                       errors={errors} placeholder={'Key'} options={{required: true}}/>
            <TextInput name={'placeholder'} type={'text'} label={'Placeholder'} register={register}
                       errors={errors} placeholder={'Placeholder'} options={{required: false}}/>
            <TextInput name={'required'} type={'checkbox'} label={'Required'} register={register}
                       errors={errors} placeholder={'Required'} options={{required: false}}/>
            <FormGroup>
                <Btn attrBtn={{
                    className: 'd-block w-100 mt-4',
                    color: 'primary',
                    type: 'submit'
                }}>{extraField ? 'Update' : 'Create'}</Btn>
            </FormGroup>
        </Form>
    </Fragment>);
};

export default ExtraFieldForm;
